module.exports = {
      id: "arrow-circle-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.91580017.svg#arrow-circle-usage",
      toString: function () {
        return this.url;
      }
    }